import { Result } from 'antd';
import React, {  } from 'react';
import { MasterSelect } from '../common/MasterSelect';
import { useSelector } from 'react-redux';
import { store } from '../../store';

export const preAuthzFn = (allowedRoles:string, userRole:string, ) => {
    const all = allowedRoles.split(',');
    if (userRole === undefined) {
        return false
    }
    const scopes = userRole.split(",");
    for (let role of all) {
        if (scopes.indexOf(role) >= 0) {
            return true
        }
    }

    return false
};

export const preAuthzElementFn = (elment:string, skipOnUndefinedElement:boolean = false) => {
    if(skipOnUndefinedElement && elment === undefined) {
        return true
    }
    const permissedElements = (store.getState() as any)?.hierarchicalElement?.permissedElements || {}
    return permissedElements[elment] ? true : (Object.keys(permissedElements).find((key:string) => key.startsWith(elment+'-')) ? true : false)
};



export const PreAuthz = ({ allowedRoles, children, hideResult, allowedElementName }: { allowedRoles?: string; children: any, hideResult?:boolean, allowedElementName?: string}) => {
    
    const { userinfo, data } = useSelector((state: any) => state.login)

    const { permissedElements } = useSelector((state: any) => state.hierarchicalElement)


    if (userinfo === undefined) {
        return <>Loading</>
    }
    console.log("permissedElements", permissedElements, allowedElementName)

    if(allowedElementName) {
            if (permissedElements[allowedElementName]) {
                return children
        }
        if (hideResult) {
            return null
        }
        return <Result
            status="403"
            title="403"
            subTitle="Sorry, you are not authorized to access this page."        
        />
    }

    // const all = allowedRoles.split(',');
    // const scopes = userinfo.userRole.split(",");
    // for (let role of all) {
    //     if (scopes.indexOf(role) >=0 ) {
    //      return <>
    //             {children}
    //         </>
    //     }
    // }

    if (hideResult) {
        return null
    }

    return <Result
        status="403"
        title="403"
        subTitle="Sorry, you are not authorized to access this page."        
    />


};

